import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { LinkCardContext } from '../contexts/StoreContext'
import { LinkCardStore } from '../store/interface'

export const useLinkCardStore: UseStore<LinkCardStore> = selector => {
  return useContextStore(LinkCardContext, selector)
}

export const useLinkCardStoreApi = () => {
  return useContextStoreApi(LinkCardContext)
}
